"use client"

import style from './DropDown.module.scss'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { IoMdArrowDropdown } from "react-icons/io";
import Image from 'next/image'
import {useAxios} from "hooks/useAxios";
import React, {useEffect, useState} from "react";
import { useSWRConfig} from "swr"
import {reverseTranslateSegments, translateSegments} from "../../lib/pathTranslation";

function getRegionFromLocale(locale) {
    if (typeof locale !== 'string') return null;

    const parts = locale.split('-');
    return parts.length === 2 ? parts[1].toUpperCase() : 'GB';
}

export const DropDown = ({ icon, locale}) =>{
    const {get} = useAxios();
    const [langCookie, setLangCookie] = useState();
    const [countryCookie, setCountryCookie] = useState();
    const {mutate} = useSWRConfig()
    const [vertalingData, setVertalingData] = useState()

    useEffect(() => {
        get('/released/languages')
            .then((res) => {
                const dataLang = []

                res.data.forEach((d) => {
                    const obj = {
                        id: d.id,
                        name: d.naam,
                        img: `fi fi-${d.alpha_code?.toLowerCase()}`,
                        displayImage: true
                    }

                    dataLang.push(obj)
                })

                setVertalingData(dataLang)
            })
    }, []);

    useEffect(() => {
        if (typeof document === "undefined") return;

        const cookie = document.cookie
            .split('; ')
            .find((row) => row.startsWith(`NEXT_LOCALE=`))
            ?.split('=')[1];

        const splittedCookie = cookie.split('-')
        setLangCookie(splittedCookie[0]);
        setCountryCookie(splittedCookie[1]);
    }, []);
    const setTaal = (taal, newLocale) =>{
        // this is so the language settings stay in sync with the user account settings (important for mail)
        get( `/locale/${taal}`).then(response =>{
            if(response.status === 200) {
                mutate(key => true)

                // Get current path and translate segments
                const currentPath = window.location.pathname;
                const currentLocaleMatch = currentPath.match(/^\/([a-z]{2}-[a-z]{2})(\/.*)?$/i);
                const currentParams = window.location.search;

                if (currentLocaleMatch) {
                    const currentLocaleFull = currentLocaleMatch[1];
                    const currentLang = currentLocaleFull.split('-')[0];
                    const newLang = newLocale.split('-')[0];
                    const restOfPath = currentLocaleMatch[2] || '';

                    // Remove locale slug from path
                    const cleanedPath = restOfPath;

                    // Reverse translate from current language to canonical form
                    const canonicalPath = reverseTranslateSegments(cleanedPath, currentLang);

                    // Translate to new language
                    const translatedPath = translateSegments(canonicalPath, newLang);
                    // Build new URL with translated path
                    window.location.href = `/${newLocale}${translatedPath}${currentParams}`;
                } else {
                    // No locale in URL, just reload
                    window.location.reload();
                }
            }
        })


    }

    return    <Menu as="div" className={`relative inline-block text-left 4 ${style.dropdownContainer}`}>
        <div>
            <MenuButton className="inline-flex w-full justify-center gap-x-1.5px-3 py-2 text-sm">
                {icon}
                <IoMdArrowDropdown aria-hidden="true" className="-mr-1 h-5 w-5" />
            </MenuButton>
        </div>

        <MenuItems
            transition
            className="z-[99999] absolute right-0 z-10 mt-2 w-56 origin-top-right bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
        >
            <div className="py-1">

                {vertalingData && vertalingData.map(item => {
                    const {id, name, img} = item

                    return <MenuItem  key={`${id}-${name}`}>
                        <div
                            className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 cursor-pointer"
                            onClick={function () {
                                const localeFull = `${name.toLowerCase()}-${countryCookie}`;
                                document.cookie = `NEXT_LOCALE=${encodeURIComponent(localeFull)}; Path=/; Max-Age=31536000; SameSite=Lax`;

                                setTaal(name.toLowerCase(), localeFull)
                                }}
                        >

                            <div className={`flex items-center gap-3`}>
                                <span className={`${img} w-[20px] h-[14px]`}></span>
                                <span>{name}</span>
                            </div>
                        </div>
                    </MenuItem>
                })}
            </div>
        </MenuItems>
    </Menu>


}